import Types from '../modules/types';

const tests = Types.ROLE.reduce(
  (agr, role) => {
    ['===', '!=='].forEach(op => ['user', 'viewer'].forEach((type) => {
      agr[`${
        type
      }${
        op === '===' ? 'Is' : 'IsNot'
      }${
        role[0]
      }${
        role.slice(1).toLowerCase()
      }`] = (
          type === 'user'
        ? (props) => {
            let value = null;
            if (props.form) {
              value = props.form.getFieldValue('role');
            }
            if (!value && props.data) {
              value = props.data.role;
            }
            return op === '==='
            ? value === role
            : value !== role;
          }
        : [
            'condition.checkViewer',
            'role',
            op,
            role,
          ]
      );
    }));
    return agr;
  },
  {},
);

tests.activityIsNotCreate = ({ activity }) => activity !== 'create';
tests.activityIsNotEdit = ({ activity }) => activity !== 'edit';

tests.viewerIsUserOwner = props => (
     props.data
  && props.viewer
  && props.data._id === props.viewer._id
);

tests.viewerIsNotUserOwner = [
  'condition.not',
  tests.viewerIsUserOwner,
];

tests.viewerIsNotAdminWithEmail = (emails = []) => props => (
      props.viewer?.role !== 'ADMIN'
  || !emails.includes(props.viewer?.email)
);

tests.userIsAdminWithEmail = (emails = []) => props => (
  props.data?.role === 'ADMIN'
  && emails.includes(props.data?.email)
);

tests.viewerIsNotAdminWithEmail.THEHIVERS_EMAILS = [
  'nikolakanacki@thehive.rs',
  'markoradak@thehive.rs',
  'ivanprtljaga@thehive.rs',
  'katarinasava@thehive.rs',
  'admin@vatrovrsac-server.com',
];

tests.userIsAdminWithThehiveRsEmail = tests.userIsAdminWithEmail(
  tests.viewerIsNotAdminWithEmail.THEHIVERS_EMAILS,
);

tests.viewerIsNotThehiveRsAdmin = tests.viewerIsNotAdminWithEmail(
  tests.viewerIsNotAdminWithEmail.THEHIVERS_EMAILS,
);

export default tests;
